<div class="container-fluid py-4" *ngIf="quote_info && presentation_info">
	<div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
		<h1 class="h3">Diseñador de PDF Comercial - Cotización #{{quote_info.quote.id}}</h1>
		<div class="d-flex gap-2">
			<!-- TEMPLATES DROPDOWN -->
			<div class="dropdown">
				<button class="btn btn-outline-info dropdown-toggle" type="button" data-bs-toggle="dropdown">
					Plantillas
				</button>
				<ul class="dropdown-menu shadow">
					<li><button class="dropdown-item" (click)="saveAsTemplate()">Guardar como Plantilla...</button></li>
					<li *ngIf="templates.length > 0"><hr class="dropdown-divider"></li>
					<li *ngIf="templates.length > 0"><h6 class="dropdown-header">Aplicar Plantilla:</h6></li>
					<li *ngFor="let t of templates">
						<button class="dropdown-item" (click)="applyTemplate(t.id)">{{t.name}}</button>
					</li>
				</ul>
			</div>

			<button class="btn btn-outline-secondary" [routerLink]="['/view-quote', quote_info.quote.id]">Regresar</button>
			<button class="btn btn-primary" (click)="savePresentation()">Guardar Global</button>
			<a class="btn btn-success" [routerLink]="['/print-custom-quote', quote_info.quote.id]">Vista Previa / Imprimir</a>
		</div>
	</div>

	<div class="row">
		<!-- PANEL IZQUIERDO: CONSTRUCTOR -->
		<div class="col-12 col-lg-7">
			<div class="card shadow-sm mb-4">
				<div class="card-header bg-light">
					<h5 class="card-title mb-0">Información de Presentación</h5>
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-md-6 mb-3">
							<label class="form-label">Nombre del Proyecto</label>
							<input type="text" class="form-control" [(ngModel)]="presentation_info.presentation.project_name" placeholder="Ej: Remodelación Oficinas Centrales">
						</div>
						<div class="col-md-6 mb-3">
							<label class="form-label">Simbología / Referencia</label>
							<input type="text" class="form-control" [(ngModel)]="presentation_info.presentation.symbology" placeholder="Ej: COT-2024-001">
						</div>
					</div>
				</div>
			</div>

			<!-- IMAGENES -->
			<div class="card shadow-sm mb-4">
				<div class="card-header bg-light d-flex justify-content-between align-items-center">
					<h5 class="card-title mb-0">Imágenes (Visuales y Detalles)</h5>
					<div>
						<input type="file" #fileInput (change)="uploadImage($event, 'PRIMARY_VISUAL')" style="display:none">
						<button class="btn btn-sm btn-outline-primary" (click)="fileInput.click()">+ Agregar Imagen</button>
					</div>
				</div>
				<div class="card-body">
					<div class="row g-2">
						<div class="col-4 col-md-3" *ngFor="let img of presentation_info.images; let i = index">
							<div class="position-relative border rounded p-1">
								<img [src]="rest.getImagePath(img.image_id)" class="img-fluid rounded" style="height: 100px; width: 100%; object-fit: cover;">
								<button class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1" (click)="deleteImage(img, i)">&times;</button>
								<div class="dropdown mt-1">
									<button class="btn btn-xs btn-outline-primary w-100 py-0" type="button" data-bs-toggle="dropdown" style="font-size: 0.7rem;">
										Asignar...
									</button>
									<ul class="dropdown-menu shadow" style="font-size: 0.8rem;">
										<li *ngFor="let sInfo of presentation_info.sections">
											<button class="dropdown-item" (click)="assignImageToSection(img, sInfo, i)">{{sInfo.section.name}}</button>
										</li>
										<li *ngIf="presentation_info.sections.length === 0">
											<span class="dropdown-item-text text-muted">Crea una sección primero</span>
										</li>
									</ul>
								</div>
								<div class="mt-1 small text-center text-truncate" style="font-size: 0.7rem;">{{img.type}}</div>
							</div>
						</div>
						<div class="col-12 text-center py-4 text-muted" *ngIf="presentation_info.images.length === 0">
							No hay imágenes cargadas.
						</div>
					</div>
				</div>
			</div>

			<!-- SECCIONES -->
			<div class="mb-3 d-flex gap-2">
				<input type="text" class="form-control" [(ngModel)]="new_section_name" placeholder="Nombre de la nueva sección...">
				<button class="btn btn-primary text-nowrap" (click)="addSection()">+ Agregar Sección</button>
			</div>

			<div *ngFor="let sectionInfo of presentation_info.sections; let sIdx = index" class="card shadow-sm mb-4 border-primary">
				<div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
					<div class="d-flex align-items-center gap-2 flex-grow-1">
						<button class="btn btn-sm btn-danger border-white" (click)="deleteSection(sectionInfo, sIdx)" title="Eliminar Sección">&times;</button>
						<input type="text" class="form-control form-control-sm bg-white text-dark border-0 fw-bold px-2" [(ngModel)]="sectionInfo.section.name" (blur)="updateSection(sectionInfo.section)" style="box-shadow: none; font-size: 1rem;">
					</div>
					<div class="d-flex align-items-center gap-2">
						<select class="form-select form-select-sm" [(ngModel)]="sectionInfo.section.price_display_mode" (change)="updateSection(sectionInfo.section)">
							<option value="SUM">Mostrar Suma</option>
							<option value="HIDDEN">Ocultar Precio</option>
							<option value="DETAILED">Detallado</option>
						</select>
						<span class="badge bg-white text-primary">Total: {{getSectionTotal(sectionInfo) | currency}}</span>
					</div>
				</div>
				<div class="card-body">
					<div class="mb-3">
						<h6 class="border-bottom pb-1 mb-2">Descripción Narrativa</h6>
						<div *ngFor="let row of sectionInfo.rows; let rIdx = index" class="row g-2 mb-2 align-items-start">
							<div class="col-md-4">
								<input type="text" class="form-control form-control-sm" [(ngModel)]="row.label" (blur)="updateRow(row)" placeholder="Etiqueta (Ej: Material)">
							</div>
							<div class="col-md-7">
								<textarea class="form-control form-control-sm" [(ngModel)]="row.description" (blur)="updateRow(row)" rows="1" placeholder="Descripción..."></textarea>
							</div>
							<div class="col-md-1">
								<button class="btn btn-outline-danger btn-sm w-100" (click)="deleteRow(sectionInfo, row, rIdx)">&times;</button>
							</div>
						</div>
						<button class="btn btn-sm btn-link p-0" (click)="addRow(sectionInfo)">+ Agregar Renglón</button>
					</div>

					<div class="mb-3" *ngIf="sectionInfo.images.length > 0">
						<h6 class="border-bottom pb-1 mb-2">Imágenes de la Sección</h6>
						<div class="row g-2">
							<div class="col-3" *ngFor="let img of sectionInfo.images; let imgIdx = index">
								<div class="position-relative border rounded p-1">
									<img [src]="rest.getImagePath(img.image_id)" class="img-fluid rounded" style="height: 60px; width: 100%; object-fit: cover;">
									<button class="btn btn-outline-secondary btn-xs position-absolute top-0 end-0 m-1 bg-white" (click)="unassignImageFromSection(img, sectionInfo, imgIdx)" title="Desvincular">&times;</button>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-3">
						<h6 class="border-bottom pb-1 mb-2">Artículos Técnicos Vinculados (Costos)</h6>
						<div class="table-responsive">
							<table class="table table-sm table-hover align-middle">
								<thead class="table-light">
									<tr>
										<th>Artículo</th>
										<th class="text-end">Total</th>
										<th class="text-end" style="width: 40px;"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let link of sectionInfo.links; let lIdx = index">
										<td>{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.item?.name }}</td>
										<td class="text-end">{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.quote_item?.total | currency }}</td>
										<td class="text-end">
											<button class="btn btn-outline-danger btn-sm border-0" (click)="unlinkItem(sectionInfo, link, lIdx)">&times;</button>
										</td>
									</tr>
									<tr *ngIf="sectionInfo.links.length === 0">
										<td colspan="3" class="text-center text-muted small py-2">No hay artículos técnicos vinculados. Arrastra desde la derecha.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- PANEL DERECHO: ARTICULOS TECNICOS -->
		<div class="col-12 col-lg-5">
			<div class="card shadow-sm sticky-top" style="top: 1rem; max-height: 90vh; overflow-y: auto;">
				<div class="card-header bg-dark text-white">
					<h5 class="card-title mb-0">Artículos Técnicos (Inventario)</h5>
				</div>
				<div class="card-body p-0">
					<div class="list-group list-group-flush">
						<div *ngFor="let qi of quote_info.items" class="list-group-item d-flex justify-content-between align-items-center" 
							[ngClass]="{'bg-light text-muted': isItemLinked(qi.quote_item.id)}">
							<div>
								<div class="fw-bold">{{qi.item.name}}</div>
								<small>{{qi.quote_item.qty}} x {{qi.quote_item.unitary_price | currency}}</small>
							</div>
							<div class="d-flex align-items-center gap-2">
								<span class="fw-bold">{{qi.quote_item.total | currency}}</span>
								<div class="dropdown">
									<button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" [disabled]="isItemLinked(qi.quote_item.id)">
										Asignar a...
									</button>
									<ul class="dropdown-menu dropdown-menu-end shadow">
										<li *ngFor="let sInfo of presentation_info.sections">
											<button class="dropdown-item" (click)="linkItem(sInfo, qi.quote_item)">{{sInfo.section.name}}</button>
										</li>
										<li *ngIf="presentation_info.sections.length === 0">
											<span class="dropdown-item-text text-muted">Crea una sección primero</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card-footer bg-light">
					<div class="d-flex justify-content-between fw-bold">
						<span>Gran Total Cotización:</span>
						<span>{{quote_info.quote.total | currency}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-loading [is_loading]="is_loading"></app-loading>
